import modelBaseV2 from "../model-base-v2.model";

const DeactivationManagementExcelModel = {
  getDeactivationTypes: () => {
    return modelBaseV2.get("/api/deactivation/deactivationTypeGet");
  },

  getRecExcelLimit: (deactivationType) => {
    return modelBaseV2.get("/api/deactivation/recExcelLimit", {
      params: { deactivationType },
    });
  },

  getBackDayLimit: (deactivationType) => {
    return modelBaseV2.get("/api/deactivation/backDayLimit", {
      params: { deactivationType },
    });
  },

  isChannelSystemAdmin: () => {
    return modelBaseV2.get("/api/user/isChannelSystemAdmin");
  },

  uploadToDeactivate: (deactivationType, formData, workRequesterId) => {
    const params = workRequesterId
      ? { deactivationType, workRequesterId }
      : { deactivationType };

    return modelBaseV2.post("/api/deactivation/:deactivationType", {
      params,
      body: formData,
    });
  },

  checkAccess: (deactivationType) => {
    return modelBaseV2.get("/api/deactivation/authCheck", {
      params: { deactivationType },
    });
  },

  downloadResult: (fileId, filename) => {
    return modelBaseV2.getDownload(
      "/api/file/temp/:fileId",
      {
        params: { fileId },
      },
      filename
    );
  },

  downloadExcelTemplate: (storedProcedureCode, fileName = "template") => {
    const exportConfig = {
      storedProcedureCode,
      params: [],
    };
    return modelBaseV2.postDownload(
      "/api/executesp/export/file",
      {
        body: exportConfig,
      },
      fileName
    );
  },
};

export default DeactivationManagementExcelModel;
